import { Box, OutlinedInput } from "@mui/material";
import { BackgroundStyle, BigHeading, FlexContainer, LightBlueContainer, ListContainer, SearchingBoxContainer, LongBlueButton } from "../assets/style";
import RecordTable, { TableRow, TableHeader } from "../components/RecordTable";
import { useState } from "react";
import SearchInput from "../components/SearchInput";
import SearchDatePicker from "../components/SearchDatePicker";
import dayjs from 'dayjs';
import SearchBox from "../components/SearchBox";
import MainContent from '../components/MainContent';
import { useNavigate } from "react-router-dom";
import { workPageName } from "../components/PageName";
import { useTranslation } from "react-i18next";

const WorkRecordListPage = () => {
    const {t, i18n} = useTranslation();
    const [projectNum, setProjectNum] = useState("");
    const [date, setDate] = useState(dayjs(null));
    const [projectName, setProjectName] = useState("");
    const [location, setLocation] = useState("");
    const navigate = useNavigate();
    const columns: TableHeader[] = [
        { field: 'worker', headerName: t('Worker Name'), width: 200, isSortable: true },
        { field: 'projectNum', headerName: t('Project No.'), width: 300, isSortable: true },
        { field: 'projectName', headerName: t('Project Name'), width: 200, isSortable: false },
        { field: 'location', headerName: t('Location'), width: 300, isSortable: false },
        { field: 'locationOfConfinedSpace', headerName: t('Location of Confined Space'), width: 300, isSortable: false },
        { field: 'onSiteDay', headerName: t('On Site Day'), width: 200, isSortable: false },
        { field: 'role', headerName: t('Role'), width: 200, isSortable: false },
        { field: 'TimeIn', headerName: t('Date/Time In'), width: 200, isSortable: false },
        { field: 'TimeOut', headerName: t('Date/Time Out'), width: 200, isSortable: false },
        { field: 'rfid', headerName: t('RFID No.'), width: 200, isSortable: false },
        { field: 'qrCode', headerName: t('QR Code'), width: 200, isSortable: false },
    ];

    const rows = [
        {
            id: 1,
            worker: "Chan Tai Man",
            projectNum: 1,
            projectName: "project A",
            location: "location 1",
            locationOfConfinedSpace: "Confined Space 1",
            onSiteDay: "2022-01-01",
            role: "Proprietor",
            TimeIn: "01/01/2024 13:26",
            TimeOut: "01/01/2024 18:26",
            rfid: "A113926",
            qrCode: "QR 1",
        },
        {
            id: 2,
            worker: "Lee Tai Man",
            projectNum: 2,
            projectName: "project B",
            location: "location 2",
            locationOfConfinedSpace: "Confined Space 2",
            onSiteDay: "2022-01-02",
            role: "Personnel Entering",
            TimeIn: "01/02/2024 13:26",
            TimeOut: "01/02/2024 18:26",
            rfid: "A113927",
            qrCode: "QR 2",
        }
    ];

    const handleRowClick = (work: any) => {
        // Handle the row click event and pass the row value to another page or component
        navigate('/work-detail', { state: { work } });
    };

    return (
        <MainContent type={workPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <ListContainer className="data-table-overide-styles">
                    <BigHeading>{t("Work Record")}</BigHeading>
                    <SearchingBoxContainer>
                        <SearchBox>
                            <FlexContainer>
                                <SearchInput title={t("Worker Name")} value={projectNum} setMethod={setProjectNum} />
                                <SearchInput title={t("Project No.")} value={projectName} setMethod={setProjectName} />
                                <SearchInput title={t("Project Name")} value={projectNum} setMethod={setProjectNum} />

                                <SearchInput title={t("RFID No.")} value={projectName} setMethod={setProjectName} />
                                <SearchInput title={t("Location of Confined Space")} value={projectName} setMethod={setProjectName} />
                                <SearchInput title={t("Role")} value={projectName} setMethod={setProjectName} />

                                <SearchDatePicker title={t("Date")} value={date} setMethod={setLocation} />
                            </FlexContainer>
                            <FlexContainer>
                                <LongBlueButton>{t("Search")}</LongBlueButton>
                            </FlexContainer>
                        </SearchBox>
                    </SearchingBoxContainer>
                    <RecordTable columns={columns} rows={rows} checkbox={false} onClick={handleRowClick}></RecordTable>
                </ListContainer>
            </BackgroundStyle>
        </MainContent >
    );
};
export default WorkRecordListPage;